import { Box, Grid } from "@mui/material";
import React, { useContext, useState } from "react";
import PageHeader from "../../../components/PageHeader";
import SidebarContext from "../../../context/SidebarContext";
import PaymentViewInstruction from "./payment-view-instruction";
import SimpleBar from "simplebar-react";

export default function PaymentIntegration() {
  const { open } = useContext(SidebarContext);
  const [checkStatusHeader, setCheckStatusHeader] = useState();
  const [checkBtnStatus, setCheckBtnStatus] = useState(false);

  console.log(checkStatusHeader);

  return (
    // <Box
    //   sx={{
    //     display: "flex",
    //     flexDirection: "column",
    //     height: "96vh",
    //     // margin: "10px",
    //     marginRight: "0px",
    //     width: open === true ? "calc(100vw - 240px)" : "calc(100vw - 80px)",
    //     backgroundColor: "white",
    //     padding: "20px",
    //     borderRadius: "12px",
    //   }}
    // >

    //   {/* <Box sx={{ borderBottom: "1px solid #E5E5E8" }}>
    //     <PageHeader pageTitle={"Payment Integration"} />
    //   </Box> */}

    //   <PaymentViewInstruction />
    // </Box>
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "96vh",
        margin: "20px",
        marginRight: "0px",
        width: open === true ? "calc(98vw - 240px)" : "calc(98vw - 80px)",
        backgroundColor: "white",
        paddingLeft: "20px",
        paddingTop: "20px",
        borderRadius: "12px",
        paddingBottom: "0px",
      }}
    >
      {checkStatusHeader?.agreement === true &&
      checkStatusHeader?.payment === true &&
      checkBtnStatus === true ? (
        <Box sx={{ borderBottom: "1px solid #E5E5E8", paddingRight: "20px" }}>
          <PageHeader pageTitle={"Payment Integration Options"} />
        </Box>
      ) : (
        <Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box className="flex items-center justify-center">
              <label
                className="me-2"
                style={{
                  textAlign: "left",
                  fontSize: " 26px",
                  fontWeight: "bold",
                }}
              >
                Connect Payment
              </label>
            </Box>
          </Box>
        </Box>
      )}
      <SimpleBar
        forceVisible="y"
        autoHide={true}
        style={{ maxHeight: "86vh", paddingRight: "20px" }}
        className="custom-scrollbar"
      >
        <PaymentViewInstruction
          checkHeader={setCheckStatusHeader}
          checkbtn={setCheckBtnStatus}
        />
      </SimpleBar>
    </Box>
  );
}
